module.exports = __webpack_public_path__ + "static/media/D.9c064285.png";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/D.png
// module id = 1350
// module chunks = 0